export * from "./ActivityLogsPage";

export const ACTIVITY_LOGS_BREADCRUMB = { title: "Change Log" };

export const linkToActivityLogs = () => "/app/change-log";
